import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton } from '@oneaudi/unified-web-components';
import { useDispatch } from 'react-redux';
import {
  NoOffersSection,
  NoOffersWrapper,
  NoOffersTitle,
  Ctas,
  NoOfferText,
} from './NoOffers.styles';
import { clearAllFilters } from '../../reducers/filtersReducer';

const NoFilteredOffers: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const contactDealerURL =
    'https://www.audi.ca/en/forms/contact-dealer/?dealer_id=49&partner_id=&dag=&modelid=&source=special';
  return (
    <NoOffersSection isNoFilteredOffers>
      <NoOffersWrapper>
        <NoOffersTitle>{t('promo.noOffers.titleNoFilteredOffers')}</NoOffersTitle>
        <NoOfferText>{t('promo.noOffers.descriptionCa')}</NoOfferText>
        <Ctas>
          <TextButton
            variant="secondary"
            // eslint-disable-next-line no-script-url
            href="javascript:void(0)"
            isFullWidth
            onClick={() => dispatch(clearAllFilters())}
          >
            {t('promo.noOffers.resetFilters')}
          </TextButton>
          <TextButton href={contactDealerURL} variant="secondary" isFullWidth>
            {t('promo.noOffers.contactDealer')}
          </TextButton>
        </Ctas>
      </NoOffersWrapper>
    </NoOffersSection>
  );
};

export default NoFilteredOffers;
